import React from 'react';
import StatusBadge from './StatusBadge';

export default function SongSwitcher({ songs, activeCode, onSelect }) {
  if (songs.length < 2) return null;
  return (
    <div className="mt-10 flex flex-wrap gap-2" data-testid="song-switcher">
      {songs.map((r) => (
        <button key={r.code} onClick={() => onSelect(r.code)} data-testid={`song-tab-${r.code}`} aria-pressed={r.code === activeCode}
          className={`flex items-center gap-3 rounded-full border pl-4 pr-1.5 py-1.5 text-sm transition-colors ${r.code === activeCode ? 'border-gold/60 bg-gold/[0.06] text-cream' : 'hairline text-cream/55 hover:border-gold/30 hover:text-cream/80'}`}>
          <span className="truncate max-w-[180px]">{r.business}</span>
          <StatusBadge status={r.status} />
        </button>
      ))}
    </div>
  );
}
